import { useEffect } from 'react';
import { useSiteSettings } from '@/contexts/SiteSettingsContext';
import { useLanguage } from '@/contexts/LanguageContext';

/**
 * Updates <title> and <meta description> with CMS-configured SEO values.
 * Also updates Open Graph tags (og:title, og:description).
 * Falls back to defaults in index.html when settings are empty.
 */
export default function MetaInjector() {
  const { settings } = useSiteSettings();
  const { lang } = useLanguage();

  useEffect(() => {
    if (!settings?.seo) return;
    const isAr = lang === 'ar';
    const title = (isAr ? settings.seo.meta_title_ar : settings.seo.meta_title_en) || '';
    const desc = (isAr ? settings.seo.meta_desc_ar : settings.seo.meta_desc_en) || '';
    const ogImage = settings.seo.og_image || '';

    if (title.trim()) document.title = title;

    const ensureMeta = (selector, attr, value) => {
      if (!value) return;
      let el = document.querySelector(selector);
      if (!el) {
        el = document.createElement('meta');
        const [key, val] = selector.replace('meta[', '').replace(']', '').replace(/"/g, '').split('=');
        el.setAttribute(key, val);
        document.head.appendChild(el);
      }
      el.setAttribute(attr, value);
    };

    ensureMeta('meta[name="description"]', 'content', desc);
    ensureMeta('meta[property="og:title"]', 'content', title);
    ensureMeta('meta[property="og:description"]', 'content', desc);
    if (ogImage) ensureMeta('meta[property="og:image"]', 'content', ogImage);
    ensureMeta('meta[name="twitter:title"]', 'content', title);
    ensureMeta('meta[name="twitter:description"]', 'content', desc);
  }, [settings, lang]);

  return null;
}
